<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Interface</th>
        <th class="text-sm">Connection Status</th>
        <th class="text-sm">Admin Status</th>
        <th class="text-sm">Duplex</th>
        <th class="text-sm">Speed</th>
        <th class="text-sm">Flow Control</th>
        <th class="text-sm">MAC Address</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="7">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="portInfo?.ports && portInfo.ports.length">
        <tr
          v-for="port in portInfo.ports"
          :key="port.index"
        >
          <td class="text-sm font-weight-bold">{{ port.interface }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getConnectionClass(port.connection)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ formatConnectionStatus(port.connection) }}
            </span>
          </td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getAdminClass(port.enable)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ port.enable }}
            </span>
          </td>
          <td class="text-sm">{{ formatDuplex(port.duplex) }}</td>
          <td class="text-sm">{{ formatSpeed(port.speed) }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getFlowClass(port.flow)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ port.flow }}
            </span>
          </td>
          <td class="text-sm font-monospace">{{ port.mac }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7" class="text-center">No port status data available</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'BdcomPortStatusTable',
  components: {
    Skalaton
  },
  props: {
    portInfo: Object,
    loading: Boolean
  },
  methods: {
    formatConnectionStatus(status) {
      if (status === 'connect') return 'Connected';
      if (status === 'down') return 'Down';
      return status || 'Unknown';
    },
    
    formatDuplex(duplex) {
      return duplex || 'N/A';
    },
    
    formatSpeed(speed) {
      return speed || 'N/A';
    },
    
    getConnectionClass(status) {
      if (status === 'connect') return 'bg-success';
      if (status === 'down') return 'bg-secondary';
      return 'bg-warning';
    },
    
    getAdminClass(status) {
      if (status === 'enable') return 'bg-success';
      if (status === 'disable') return 'bg-danger';
      return 'bg-warning';
    },
    
    getFlowClass(status) {
      if (status === 'Off') return 'bg-secondary';
      if (status === 'On') return 'bg-success';
      return 'bg-warning';
    }
  }
}
</script>